// Indicadores legacy: todos os valores no Lançar são inteiros escalados (12345 = 123,45),
// independente do quantificador (R$, Un, %, etc.).
export const formatScaledIndicatorValue = (value, decimals = 2) => {
	if (value === null || value === undefined || value === "") return "";

	const isNegative = value.toString().startsWith("-");
	const cleanedValue = value.toString().replace(/[^\d]/g, "");

	if (cleanedValue === "") return isNegative ? "-" : "";

	if (decimals === 0) {
		const numValue = parseInt(cleanedValue, 10) || 0;
		return (
			(isNegative ? "-" : "") + numValue.toLocaleString("pt-BR")
		);
	}

	const intPart = cleanedValue.slice(0, -decimals) || "0";
	const decimalPart = cleanedValue.slice(-decimals).padStart(decimals, "0");
	const numValue = parseFloat(`${intPart}.${decimalPart}`);

	return (
		(isNegative ? "-" : "") +
		numValue.toLocaleString("pt-BR", {
			minimumFractionDigits: decimals,
			maximumFractionDigits: decimals,
		})
	);
};

// Percentuais e demais quantificadores: valor já é decimal (1.00 = 1%).
export const formatDecimalIndicatorValue = (value, decimals = 2) => {
	if (value === null || value === undefined || value === "") return "";

	const number = typeof value === "number" ? value : parseFloat(value);
	if (isNaN(number)) return "";

	const fixedNumber = number.toFixed(decimals);
	const [integerPart, decimalPart] = fixedNumber.split(".");

	const integerWithSeparators = integerPart.replace(
		/\B(?=(\d{3})+(?!\d))/g,
		".",
	);

	return decimalPart
		? `${integerWithSeparators},${decimalPart}`
		: integerWithSeparators;
};

export const formatIndicatorDisplayValue = (
	value,
	quantifier,
	decimals_cases,
	isLegacy = false,
) => {
	const decimals = decimals_cases !== null && decimals_cases !== undefined && decimals_cases !== "" ? Number(decimals_cases) : 2;

	// Indicadores legacy armazenam TODOS os valores como inteiros escalados
	// (ex: 240000 = 2.400,00), independente do quantificador.
	// Indicadores novos (variables) armazenam o valor já como decimal
	// (ex: 10000 = 10.000,00), inclusive R$.
	const formattedNumber = isLegacy
		? formatScaledIndicatorValue(value, decimals)
		: formatDecimalIndicatorValue(value, decimals);

	if (!formattedNumber || formattedNumber === "-") return formattedNumber;

	if (quantifier === "R$") {
		return `R$ ${formattedNumber}`;
	}

	if (!quantifier) {
		return formattedNumber;
	}

	return `${formattedNumber} ${quantifier}`;
};
